module.exports = __webpack_public_path__ + "img/middle.4c1b72bf.svg";